import React from "react";
import { createStyles } from "@mantine/core";
import mixpanel from "mixpanel-browser";
import { PopupButton } from "react-calendly";

const useStyles = createStyles((theme) => ({
  reactCalendlyButtonWrapper: {
    padding: "24px 0px",
  },
  primaryBtn: {
    background: '#262626',
    border: "1px solid #262626",
    color: "#FFF",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "600",
    width: "auto",
    height: "auto",
    lineHeight: "24px",
    padding: "12px 20px",
    borderRadius: "8px",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    cursor: "pointer",
    "&:hover": {
      background: '#262626',
      color: "#FFF",
      opacity: "0.8",
    },
    "@media (max-width: 768px)": {
      padding: ".5rem 2rem",
      fontSize: "14px",
      fontWeight: "600",
    },
  },
  buttonLink: {
    textDecoration: "none",
    color: "#fff",
  },
}));

export const DemoBookButton = () => {
  const { classes } = useStyles();

  return (
    <div className="inline-widget">
        <div
          className={classes.reactCalendlyButtonWrapper}
          onClick={() => mixpanel.track("demo booked")}
        >
          <PopupButton
            className={classes.primaryBtn}
            url="https://calendly.com/ogiso-demo/30min?primary_color=ffba45"
            rootElement={document.getElementById("root")}
            text="Book a Demo"
          />
        </div>
    </div>

    // <Link
    //   target="_blank"
    //   className={classes.buttonLink}
    //   to="https://calendly.com/ogiso-demo/30min?primary_color=ffba45"
    // >
    //   <Button className={classes.primaryBtn}>Book a Demo</Button>
    // </Link>
  );
};
